import { createRouter, createWebHistory } from "vue-router";
import { authRoutes } from "./modules/auth/routes";
import { userCartRoutes } from "./modules/user-cart/routes";
import { ProfileRoute } from "./modules/profile/routes";
import sellerIndexPage from "./pages/seller/index.vue";
import infoPage from "./pages/info/index.vue";
import HomePage from "./pages/home/index.vue";
import MembersPage from "./pages/members/index.vue";
import ProductsPage from "./pages/products/index.vue";
import ProductDetailPage from "./pages/products/detail.vue";
import galleryPage from "./pages/gallery/index.vue";
import followersPage from "./pages/followers/index.vue";
import customersClubPage from "./pages/customersClub/index.vue";
import Error404 from "./pages/error/err-404.vue";

import weblogPage from "./pages/weblog/index.vue";
import mapPage from "./pages/map/index.vue";
import chatPage from "./pages/chat/index.vue";
import { orderRoutes } from "./modules/orders/routes";

import businesRegisterPage from "./pages/businesRegister/index.vue";

const routes = [
  { ...authRoutes },
  { ...userCartRoutes },
  { ...ProfileRoute },
  { ...orderRoutes },
  {
    path: "/",
    beforeEnter(to, from, next) {
      window.location.href = "https://faliznet.ir/";
      next();
    },
  },
  { path: "/info", component: infoPage },
  { path: "/customers-club", component: customersClubPage },
  {
    path: "/show/:id",
    beforeEnter(to) {
      if (to.params.id != 354223011678)
        window.location.href = "https://witrino.com/show/" + to.params.id;
      else window.location.href = "https://faliznet.ir/" + to.params.id;
    },
  },
  {
    path: "/:token",
    component: sellerIndexPage,
    children: [
      { path: "", component: HomePage },
      { path: "members", component: MembersPage },
      { path: "products", component: ProductsPage },
      { path: "products/:id", component: ProductDetailPage },
      { path: "gallery", component: galleryPage },
      { path: "followers", component: followersPage },
      { path: "weblog", component: weblogPage },
      { path: "map", component: mapPage },
      { path: "busines_register", component: businesRegisterPage },
      { path: "chat/:id", component: chatPage },
    ],
  },
  {
    path: "/404",
    component: Error404,
  },
];

const router = createRouter({
  history: createWebHistory("/witrin"),
  routes,
});

export default router;
